import { ETTypeInfos } from "@cervval.js/common-dto/src/dtoModel.service";
import { keys, typeInfos } from "@cervval.js/ts-reflect";
import { UsersElementTypes } from "../users/user.model";
import { PaymentDTO, ProPaymentDTO, ProSubscriptionDTO, SubscriptionDTO } from "./payment.dto";
import { ProductDTO } from "./product.dto";

export type PaymentElementTypes = {
    "payments": PaymentDTO,
    "subscriptions": SubscriptionDTO,
    "pro_payments": ProPaymentDTO,
    "pro_subscriptions": ProSubscriptionDTO,
    "products": ProductDTO
}

export type PaymentElementTypeNames = keyof PaymentElementTypes;
export const PaymentElementTypeNames: PaymentElementTypeNames[] = keys<PaymentElementTypes>();

export const paymentTypeInfos: ETTypeInfos<PaymentElementTypes, PaymentElementTypes & UsersElementTypes> = {
    "payments": {
        keys: keys<PaymentDTO>(),
        typeInfos: typeInfos<PaymentDTO>(),
        foreignKeys: {
            customerId: "user_profiles",
            supplierId: "companies",
            subscriptionId: "subscriptions"
        },
        archivedField: "archived"
    },
    "pro_payments": {
        keys: keys<PaymentDTO>(),
        typeInfos: typeInfos<PaymentDTO>(),
        foreignKeys: {
            customerId: "companies",
            supplierId: "companies",
            subscriptionId: "pro_subscriptions"
        },
        archivedField: "archived"
    },
    "subscriptions": {
        keys: keys<SubscriptionDTO>(),
        typeInfos: typeInfos<SubscriptionDTO>(),
        foreignKeys: {
            customerId: "user_profiles",
            supplierId: "user_profiles"
        },
        archivedField: "archived"
    },
    "pro_subscriptions": {
        keys: keys<ProSubscriptionDTO>(),
        typeInfos: typeInfos<ProSubscriptionDTO>(),
        foreignKeys: {
            customerId: "companies",
            supplierId: "companies"
        },
        archivedField: "archived"
    },
    "products": {
        keys: keys<ProductDTO>(),
        typeInfos: typeInfos<ProductDTO>(),
        foreignKeys: {
            ownerCompanyId: "companies",
            professionalId: "user_profiles"
        },
        archivedField: "archived"
    }

};